/**
 * Product url change handler
 *
 * Updates urls baased on current product page selections.
 *
 * Events:
 *
 * @subscribes dimension-hash-selected <material-dimension-hash-id>
 * @subscribes comment-section-selected <comment-section-label>
 *
 */

var sw = require('./../sw');
var _ = require('underscore');

function changeQueryParams(params) {

  var url = document.createElement('a');
  url.href = window.location.toString();

  var search = url.search.replace('?', '');
  var queryParts = search.split('&');


  var queryParams = {};
  _.each(queryParts, function(part) {

    if (!part.length) {
      return;
    }

    var vals = part.split('=');
    queryParams[vals[0]] = vals[1];
  });

  _.each(params, function(value, key) {
    queryParams[key] = value;
  });

  queryParts = [];
  _.each(queryParams, function(val, key) {
    queryParts.push(key + '=' + val);
  });

  url.search = queryParts.join('&');

  window.history.replaceState({}, document.title, url.href.toString());

}

if (sw.data.urlBehavior && sw.data.urlBehavior.product) {

  if (window.history && window.history.replaceState) {

    require(['js/lib/models/ModelManager'], function(ModelManager) {
      var product = ModelManager.getProduct(sw.data.urlBehavior.product.spin);

      product.on('change:currentConfigurationId', function(product, configId) {
        changeQueryParams({optionId: configId});
      });

      sw.on('comment-section-selected', function(sectionLabel) {
        changeQueryParams({conversation: sectionLabel});
      });
    });
  }

}
